import type {
  MaxLessonsPerDay,
  CreateMaxLessonsPerDayBody,
  UpdateMaxLessonsPerDayBody,
} from './types';
import { api } from '../api';

export const maxLessonsPerDayApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMaxLessonsPerDay: build.query<MaxLessonsPerDay[], void>({
      query: () => ({
        url: '/max-lessons-per-day',
      }),
      keepUnusedDataFor: 0,
      providesTags: ['MaxLessonsPerDay'],
    }),
    createMaxLessonsPerDay: build.mutation<MaxLessonsPerDay, CreateMaxLessonsPerDayBody>({
      query: (body) => ({
        url: '/max-lessons-per-day',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['MaxLessonsPerDay'],
    }),
    updateMaxLessonsPerDay: build.mutation<MaxLessonsPerDay, UpdateMaxLessonsPerDayBody>({
      query: ({ id, ...body }) => ({
        url: `/max-lessons-per-day/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['MaxLessonsPerDay'],
    }),
    deleteMaxLessonsPerDay: build.mutation<void, number>({
      query: (id) => ({
        url: `/max-lessons-per-day/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MaxLessonsPerDay'],
    }),
  }),
});

export const {
  useGetMaxLessonsPerDayQuery,
  useLazyGetMaxLessonsPerDayQuery,
  useCreateMaxLessonsPerDayMutation,
  useUpdateMaxLessonsPerDayMutation,
  useDeleteMaxLessonsPerDayMutation,
} = maxLessonsPerDayApi;
